var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemClass === 'Transfers')?_c('div',[(
      _vm.shouldShowTransferTooltip(
        _vm.reservation.stage,
        _vm.reservationStatus,
        _vm.reservation.created_at,
        _vm.reservation.status_update,
        _vm.reservation.pickup_date,
        _vm.reservation.branch.timezone
      )
    )?_c('el-popover',{attrs:{"placement":"top","trigger":"hover","width":"230"}},[_c('span',{staticClass:"text-center d-block"},[_vm._v(_vm._s(_vm.getTransferTooltipMessage(
        _vm.reservationStatus,
        _vm.reservation.created_at,
        _vm.reservation.status_update,
        _vm.reservation.pickup_date,
        _vm.reservation.branch.timezone,
        _vm.reservation.utcExpiresAt
      )))]),_c('div',{staticClass:"badge-status",class:_vm.getTransferStatusClass(
          _vm.reservation.stage,
          _vm.reservationStatus,
          _vm.reservation.created_at,
          _vm.reservation.status_update,
          _vm.reservation.pickup_date,
          _vm.reservation.branch.timezone
        ),attrs:{"slot":"reference"},slot:"reference"},[_vm._v("\n      "+_vm._s(_vm.getTransferStatusLabel(
          _vm.reservation.stage,
          _vm.reservationStatus,
          _vm.reservation.status_update
        ))+"\n    ")])]):_c('div',{staticClass:"badge-status",class:_vm.getReservationStatusClass(_vm.reservation.stage, _vm.reservationStatus)},[_vm._v("\n    "+_vm._s(_vm.getReservationStatusLabel(_vm.reservation.stage, _vm.reservationStatus))+"\n  ")])],1):_c('div',[_c('div',{staticClass:"badge-status",class:_vm.getReservationStatusClass(_vm.reservation.stage, _vm.reservationStatus)},[_vm._v("\n    "+_vm._s(_vm.getReservationStatusLabel(_vm.reservation.stage, _vm.reservationStatus))+"\n  ")]),(_vm.reservationStatus === 'ON_HOLD')?_c('el-popover',{staticClass:"curp",attrs:{"placement":"top","trigger":"hover","width":"80"}},[_c('span',{staticClass:"text-center d-block w-100"},[_vm._v(" Expiration time ")]),_c('div',{attrs:{"slot":"reference"},slot:"reference"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center mt-1"},[_c('Countdown',{attrs:{"date":_vm.reservation.utcExpiresAt,"type":"sm"}})],1)])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }